import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import { AppRouter } from './AppRouter';
render(<HelmetProvider data-id="element-1306">
    <ThemeProvider data-id="element-1307">
      <AppRouter data-id="element-1308" />
    </ThemeProvider>
  </HelmetProvider>, document.getElementById('root'));